import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { EntityProps } from 'client/types'
import CommonBreadcrumbs from 'common/components/entities/Breadcrumbs'
import { BreadcrumbsInterface } from 'common/types/entities/BreadcrumbsInterface'
import React from 'react'
import { useTypedTranslation } from 'src/shared/i18next/hooks/use-typed-translation'

function Breadcrumbs({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<BreadcrumbsInterface>) {
  const { t } = useTypedTranslation('common')

  const breadcrumbs = [
    { name: t('components.breadcrumbs.items.home'), url: '' },
    {
      name: t('components.breadcrumbs.items.demo_blog_post_category_name'),
      url: '',
    },
    { name: t('components.breadcrumbs.items.demo_blog_post_name') },
  ]

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonBreadcrumbs
        items={breadcrumbs}
        itemColor={entity.itemColor}
        lastItemColor={entity.lastItemColor}
        fontSize={entity.fontSize}
        fontStyle={entity.fontStyle}
        fontWeight={entity.fontWeight}
        fontFamily={entity.fontFamily}
        mobileFontSize={entity.mobileFontSize}
        mobileFontStyle={entity.mobileFontStyle}
        mobileFontWeight={entity.mobileFontWeight}
        mobileFontFamily={entity.mobileFontFamily}
      />
    </BaseEntityNew>
  )
}

export function getBreadcrumbsFontProperties(entity: BreadcrumbsInterface) {
  const fontProperties = entity.fontFamily
    ? [
        {
          fontFamily: entity.fontFamily,
          fontStyle: entity.fontStyle,
          fontWeight: entity.fontWeight,
        },
      ]
    : []

  if (entity.mobileFontFamily) {
    fontProperties.push({
      fontFamily: entity.mobileFontFamily,
      fontStyle: entity.mobileFontStyle,
      fontWeight: entity.mobileFontWeight,
    })
  }

  return fontProperties
}

export default Breadcrumbs
